import { Box, BoxProps } from '@apia/theme';
import { useAutocompleteContext } from './Context';
import { observer } from 'mobx-react-lite';

export const KeyHandler = observer((props: BoxProps) => {
  const handler = useAutocompleteContext();

  return (
    <Box
      {...props}
      className={`autocomplete__keyhandler ${props.className ?? ''}`}
      onKeyDown={(ev) => {
        props.onKeyDown?.(ev);

        if (!ev.isDefaultPrevented()) {
          if (ev.key.match(/^[a-z ]$/i)) {
            if (!handler.isOpen) {
              handler.open();
            }
          }

          switch (ev.code) {
            case 'ArrowDown':
              ev.preventDefault();
              handler.focusNext();
              break;
            case 'ArrowUp':
              ev.preventDefault();
              handler.focusPrevious();
              break;
            case 'Enter':
            case 'NumpadEnter':
              ev.preventDefault();

              if (handler.isOpen) {
                handler.selectFocused();
              } else {
                handler.open();
              }
              break;
            case 'End':
              if (handler.isOpen) {
                ev.preventDefault();
                handler.focusLast();
              }
              break;
            case 'Escape':
              if (handler.isOpen) {
                ev.preventDefault();
                ev.stopPropagation();

                handler.close(false);
              }
              break;
            case 'Home':
              if (handler.isOpen) {
                ev.preventDefault();
                handler.focusFirst();
              }
              break;
            case 'PageDown':
              if (handler.isOpen) {
                ev.preventDefault();
                handler.focusNext(10);
              }
              break;
            case 'PageUp':
              if (handler.isOpen) {
                ev.preventDefault();
                handler.focusPrevious(10);
              }
              break;
          }
        }
      }}
    ></Box>
  );
});
